import { TButtonOption } from '../../../types/options';

type TCircleHierarchy = TButtonOption['hierarchy'];

const TEXT_COLOR: Record<string, string> = {
    highlighted: 'var(--color-white_base)',
    primary: 'var(--color-white_base)',
    secondary: 'var(--color-purple_100)',
    tertiary: 'var(--color-black)',
    destructive: 'var(--color-pink_100)',
};
const TEXT_DISABLED_COLOR: Record<string, string> = {
    highlighted: 'var(--color-white)',
    primary: 'var(--color-white)',
    secondary: 'var(--color-purple_40_lc)',
    tertiary: 'var(--color-grey_40_lc)',
    destructive: 'var(--color-pink_40_lc)',
};

const BG_COLOR: Record<string, string> = {
    primary: 'var(--color-purple_100)',
    secondary: 'var(--color-white)',
    tertiary: 'var(--color-white)',
    destructive: 'var(--color-white)',
    highlighted: 'var(--gradient-blue_1)',
};

const BG_DISABLED_COLOR: Record<string, string> = {
    primary: 'var(--color-purple_16_lc)',
    highlighted: 'var(--color-purple_16_lc)',
    secondary: 'var(--color-white)',
    tertiary: 'var(--color-white)',
    destructive: 'var(--color-white)',
};

const BG_HOVER_COLOR: Record<string, string> = {
    primary: 'var(--color-purple_72_hc)',
    highlighted: 'var(--color-purple_72_hc)',
    secondary: 'var(--color-purple_16_lc)',
    tertiary: 'var(--color-grey_16_lc)',
    destructive: 'var(--color-pink_16_lc)',
};

const BG_PRESSED_COLOR: Record<string, string> = {
    primary: 'var(--color-purple_72_tr)',
    highlighted: 'var(--color-purple_72_tr)',
    secondary: 'var(--color-purple_8_lc)',
    tertiary: 'var(--color-grey_8_lc)',
    destructive: 'var(--color-pink_8_lc)',
};

const ICON_COLOR: Record<string, string> = {
    primary: 'var(--color-white_base)',
    secondary: 'var(--color-purple_100)',
    tertiary: 'var(--color-black)',
    destructive: 'var(--color-pink_100)',
};

const ICON_DISABLED_COLOR: Record<string, string> = {
    primary: 'var(--color-white_40_tr_base)',
    secondary: 'var(--color-purple_40_tr)',
    tertiary: 'var(--color-grey_40_lc)',
    destructive: 'var(--color-pink_40_lc)',
};

const key = (h: TCircleHierarchy): string => h ?? 'primary';

export const getTextColor = (h: TCircleHierarchy, disabled: boolean): string => (disabled ? TEXT_DISABLED_COLOR : TEXT_COLOR)[key(h)] ?? 'var(--color-black)';

export const getCircleBg = (h: TCircleHierarchy, disabled: boolean, buttonColor?: string[]): string => {
    if (!disabled && h === 'highlighted' && buttonColor?.length) {
        return `linear-gradient(180deg, ${buttonColor.join(', ')})`;
    }
    return (disabled ? BG_DISABLED_COLOR : BG_COLOR)[key(h)] ?? 'var(--color-white)';
};

export const getCircleHoverBg = (h: TCircleHierarchy): string => BG_HOVER_COLOR[key(h)] ?? 'var(--color-grey_16_lc)';

export const getCirclePressedBg = (h: TCircleHierarchy): string => BG_PRESSED_COLOR[key(h)] ?? 'var(--color-grey_8_lc)';

export const getCircleIconColor = (h: TCircleHierarchy, disabled: boolean): string =>
    (disabled ? ICON_DISABLED_COLOR : ICON_COLOR)[key(h)] ?? 'var(--color-black)';
